import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  ApiController,
  ApiExecutor,
  ApiResponse,
  ApiValidationService,
  Body,
  GET,
  Header,
  POST,
  PUT,
} from '@app/core/api';

import {
  CompanyInformationInquiryDto,
  ContactInformationAddressInquiryDto,
  PersonalInformationInquiryDto,
  RegistrationPurpose,
  RegistrationResult,
  SaveUserPurposesDto,
  SubmitBasicInformationDto,
  SubmitContactInformationDto,
  UpdateBasicInformationDto,
  UpdateBasicInformationIsLegalDto,
  UpdateContactInformationDto,
} from '../types';


@ApiController('api/app/registration')
@Injectable({
  providedIn: 'root',
})
export class RegistrationApiService {
  constructor(
    public apiExecutor: ApiExecutor,
    public apiValidationService: ApiValidationService,
  ) {}

  @GET()
  getRegistration(): Observable<ApiResponse<RegistrationResult>> {
    return {} as Observable<ApiResponse<RegistrationResult>>;
  }

  @GET('/purposes')
  getPurposes(): Observable<ApiResponse<RegistrationPurpose[]>> {
    return {} as Observable<ApiResponse<RegistrationPurpose[]>>;
  }

  @PUT('/user/purposes')
  saveUserPurposes(@Body() dto: SaveUserPurposesDto): Observable<ApiResponse<boolean>> {
    return {} as Observable<ApiResponse<boolean>>;
  }

  @PUT('/sections/basic-information')
  updateBasicInformation(@Body() dto: UpdateBasicInformationDto): Observable<ApiResponse<RegistrationResult>> {
    return {} as Observable<ApiResponse<RegistrationResult>>;
  }

  @PUT('/sections/basic-information/isLegal')
  updateBasicInformationIsLegal(@Body() dto: UpdateBasicInformationIsLegalDto): Observable<ApiResponse<RegistrationResult>> {
    return {} as Observable<ApiResponse<RegistrationResult>>;
  }

  @POST('/sections/basic-information/submit')
  submitBasicInformation(@Body() dto: SubmitBasicInformationDto): Observable<ApiResponse<RegistrationResult>> {
    return {} as Observable<ApiResponse<RegistrationResult>>;
  }

  @PUT('/sections/personal-information')
  updatePersonalInformation(@Body() formData: FormData): Observable<ApiResponse<RegistrationResult>> {
    return {} as Observable<ApiResponse<RegistrationResult>>;
  }

  @POST('/sections/personal-information/submit')
  submitPersonalInformation(@Body() formData: FormData): Observable<ApiResponse<RegistrationResult>> {
    return {} as Observable<ApiResponse<RegistrationResult>>;
  }

  @POST('/sections/personal-information/submit/inquiry')
  inquiryPersonalInformation(@Body() dto: PersonalInformationInquiryDto): Observable<ApiResponse<RegistrationResult>> {
    return {} as Observable<ApiResponse<RegistrationResult>>;
  }

  @PUT('/sections/company-information')
  updateCompanyInformation(@Body() formData: FormData): Observable<ApiResponse<RegistrationResult>> {
    return {} as Observable<ApiResponse<RegistrationResult>>;
  }

  @POST('/sections/company-information/submit')
  submitCompanyInformation(@Body() formData: FormData): Observable<ApiResponse<RegistrationResult>> {
    return {} as Observable<ApiResponse<RegistrationResult>>;
  }

  @POST('/sections/company-information/submit/inquiry')
  inquiryCompanyInformation(@Body() dto: CompanyInformationInquiryDto): Observable<ApiResponse<RegistrationResult>> {
    return {} as Observable<ApiResponse<RegistrationResult>>;
  }

  @PUT('/sections/contact-information')
  updateContactInformation(@Body() dto: UpdateContactInformationDto): Observable<ApiResponse<RegistrationResult>> {
    return {} as Observable<ApiResponse<RegistrationResult>>;
  }

  @POST('/sections/contact-information/submit')
  submitContactInformation(@Body() dto: SubmitContactInformationDto): Observable<ApiResponse<RegistrationResult>> {
    return {} as Observable<ApiResponse<RegistrationResult>>;
  }

  @POST('/sections/contact-information/address/inquiry')
  inquiryContactInformationAddress(
    @Body() dto: ContactInformationAddressInquiryDto,
  ): Observable<ApiResponse<RegistrationResult>> {
    return {} as Observable<ApiResponse<RegistrationResult>>;
  }
}
